<template>
  <AdminConfirmModal
    v-model="getTariffDeleteModal"
    :confirm-text="$t('Default.delete')"
    confirm-color="sub white--text"
    cancel-color="main_color white--text"
    @confirm="deleteTariff"
  >
    <p class="mb-3 text-center font-20px dark-color--text">
      {{ $t("Tariffs.sure_delete") }}
      {{ currentTariff.name ? currentTariff.name : " " }}?
    </p>
    <p class="mb-8 text-center font-16px dark-color--text">
      {{ $t("Tariffs.after_delete") }}
    </p>
  </AdminConfirmModal>
</template>
<script>
import { computed } from "@vue/composition-api";
import { shortComputed } from "@/utility/helpers";
import {
  DispatchTypes,
  MutationTypes,
} from "@/store/modules/admin/tariffs/types";
import { useStore } from "vuex-composition-helpers";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  setup() {
    const store = useStore();

    const getTariffDeleteModal = shortComputed(
      {
        storeType: "tariffs",
        key: "getTariffDeleteModal",
      },
      MutationTypes.setTariffDeleteModal
    );

    const currentTariff = computed(() => store.state.tariffs.tariff);

    const deleteTariff = () => {
      store
        .dispatch(DispatchTypes.deleteTariff, currentTariff.value.id + "/")
        .then(() => {
          store.commit(MutationTypes.setTariffDeleteModal, false);
        });
    };

    return {
      store,
      getTariffDeleteModal,
      deleteTariff,
      currentTariff,
    };
  },
};
</script>
